"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CommonLogger = void 0;
var roarr_1 = __importDefault(require("roarr"));
var CommonLogger = /** @class */ (function () {
    function CommonLogger() {
    }
    CommonLogger.logger = roarr_1["default"].child({
        domain: "jewelry-platform"
    });
    return CommonLogger;
}());
exports.CommonLogger = CommonLogger;
CommonLogger.logger.debug("Common logger instantiated");
